import { useEffect } from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";

import { usePathname } from "src/routes/hooks";

import { useResponsive } from "src/hooks/use-responsive";
import { useMockedUser } from "src/hooks/use-mocked-user";

import Logo from "src/components/logo";
import Scrollbar from "src/components/scrollbar";
import { NavSectionVertical } from "src/components/nav-section";

import { NAV } from "../config-layout";
import NavUpgrade from "../common/nav-upgrade";
import { useNavData } from "./config-navigation";
import NavToggleButton from "../common/nav-toggle-button";
import { UserButton, useUser } from "@clerk/clerk-react";
import { Avatar, Button, Typography } from "@mui/material";
import Label from "src/components/label";

export default function NavVertical({ openNav, onCloseNav }) {
  const { user } = useUser();

  const pathname = usePathname();

  const lgUp = useResponsive("up", "lg");

  const navData = useNavData();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Logo sx={{ mt: 3, ml: 4, mb: 1 }} />
      <NavSectionVertical
        data={navData}
        slotProps={{
          currentRole: user?.role,
        }}
        closeNav={onCloseNav}
      />
      <Box sx={{ flexGrow: 1 }} />{" "}
      <Stack
        sx={{
          px: 2,
          py: 5,
          textAlign: "center",
        }}
      >
        <Stack alignItems="center">
          <Box sx={{ position: "relative" }}>
            <Avatar
              src={user?.imageUrl}
              alt={user?.fullName}
              sx={{ width: 48, height: 48 }}
            >
              {user?.fullName?.charAt(0).toUpperCase()}
            </Avatar>
          </Box>

          <Stack spacing={0.5} sx={{ mb: 2, mt: 1.5, width: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {user?.fullName}
            </Typography>

            <Typography variant="body2" noWrap sx={{ color: "text.disabled" }}>
              {user?.primaryEmailAddress?.emailAddress}
            </Typography>
          </Stack>
        </Stack>{" "}
        <Typography variant="subtitle2" noWrap>
          Harley | Radical Health
        </Typography>
      </Stack>
    </Scrollbar>
  );

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: "fixed",
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};
